import { User } from '../types/forum';

export const users: User[] = [
  {
    id: '1',
    username: 'GooseHunter',
    joinDate: '2019-03-15',
    postCount: 127
  },
  {
    id: '2',
    username: 'SloanLakeLocal',
    joinDate: '2020-01-22',
    postCount: 89
  },
  {
    id: '3',
    username: 'ColfaxNightWatcher',
    joinDate: '2021-06-10',
    postCount: 203
  },
  {
    id: '4',
    username: 'DenverCryptid',
    joinDate: '2022-09-05',
    postCount: 156
  },
  {
    id: '5',
    username: 'BluciferFan',
    joinDate: '2023-02-18',
    postCount: 67
  },
  {
    id: '6',
    username: 'SearchPartyLeader',
    joinDate: '2021-08-30',
    postCount: 234
  },
  {
    id: '7',
    username: 'GetGoosifer',
    joinDate: '2021-04-29',
    postCount: 45
  },
  {
    id: '8',
    username: 'monstermarathoner',
    joinDate: '2021-04-29',
    postCount: 23
  },
  {
    id: '9',
    username: 'sloanslakesleuth',
    joinDate: '2023-11-15',
    postCount: 12
  },
  {
    id: '10',
    username: 'goosed',
    joinDate: '2024-06-20',
    postCount: 8
  }
];

export const getUserById = (id: string): User | undefined => {
  return users.find(user => user.id === id);
}; 